module.exports = __webpack_public_path__ + "static/media/pcilogo.9c9a1026.png";